import src from "IMAGE";
export default { src, width: 1441, height: 3237, blurWidth: 0, blurHeight: 0};
